import React from 'react';
import { Chart } from './Chart';
import { chartsByType } from './chartTypes';
import { GreyColors } from '../../../shared/chart-options';
import NoData from '../../shared/NoData';

const getColor = ({ data }) =>
  data.selected ? GreyColors.highlight : GreyColors.color;

export const Charts = ({ selectedLineupId, displayType, lineups, onClick }) => {
  const charts = chartsByType[displayType];

  return lineups && lineups.length ? (
    <div className="s-lineup-explorer__chart-container">
      {charts.map(chart => (
        <Chart
          key={chart.name}
          data={getChartData(selectedLineupId, chart, lineups)}
          color={getColor}
          onClick={onClick}
        />
      ))}
    </div>
  ) : (
    <NoData />
  );
};

function getChartData(selectedId, chart, lineups, isPercent) {
  selectedId = +selectedId;
  return {
    name: chart.name,
    values: lineups
      .map(data => ({
        lineup: data.lineup,
        lineupId: data.lineup.id,
        value: chart.getValue(data),
        selected: data.lineup.id === selectedId,
        chartName: chart.name,
        isPercent: chart.isPercent,
      }))
      .sort((a, b) => b.value - a.value),
  };
}
